import { render, staticRenderFns } from "./TotalProfitsMadeByParticipants.vue?vue&type=template&id=cab98046&scoped=true&"
import script from "./TotalProfitsMadeByParticipants.vue?vue&type=script&lang=js&"
export * from "./TotalProfitsMadeByParticipants.vue?vue&type=script&lang=js&"
import style0 from "./TotalProfitsMadeByParticipants.vue?vue&type=style&index=0&id=cab98046&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab98046",
  null
  
)

export default component.exports